module.exports = __webpack_public_path__ + "media/src/img/facebook-icon-8efef1e149ddb39a8376bda19579afe1.svg";